import { render, staticRenderFns } from "./SensitiveContentConfirm.vue?vue&type=template&id=549ad47a&"
import script from "./SensitiveContentConfirm.vue?vue&type=script&lang=ts&"
export * from "./SensitiveContentConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports